import React from 'react'
import PhotoTileModule from '../components/photo_tile/PhotoTile';
import { projectsData } from '../constants/projectsData';

const Portfolio = () => {
  // image path is auto-generated as follows:
  // ${baseImagePath}/${item.category}/${item.title}/1.webp
  // Ex: /img/projects/Documentary/Elvis, Rocky, and Me/1.webp
  // 1.webp will be the chosen title image
  const baseImagePath = "/img/projects"

  const updatedProjectData = Object.entries(projectsData).map(([id, item]) => ({
    id,
    ...item,
    image: `${baseImagePath}/${item.category}/${item.title}/1.webp`, // Concatenate the base path with the title
  }));
  

  return (
    <div className="Tiles">
      <heCommercialer className="Tiles-heCommercialer">
        <PhotoTileModule images={updatedProjectData} />
      </heCommercialer>

    </div>
  );
}

export default Portfolio
